import React from 'react';
import type { IconProps } from './types';

export const Delete = ({ onClick }: IconProps) => (
  <div role="none" className="icon icon-menu" onClick={onClick}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.66699 7.75H17.3337V18.0833C17.3337 18.9118 16.6621 19.5833 15.8337 19.5833H8.16699C7.33857 19.5833 6.66699 18.9118 6.66699 18.0833V7.75Z" />
      <path d="M9 6.50024C9 5.67182 9.67157 5.00024 10.5 5.00024H13.5C14.3284 5.00024 15 5.67182 15 6.50024V7.50024H9V6.50024Z" />
      <line x1="5.5" y1="7.50024" x2="18.5" y2="7.50024" strokeLinecap="round" />
      <line x1="10.167" y1="11.9167" x2="10.167" y2="16.5834" />
      <line x1="13.667" y1="11.9167" x2="13.667" y2="16.5834" />
    </svg>
  </div>
);
